/* @generated */
// prettier-ignore
if (Intl.DateTimeFormat && typeof Intl.DateTimeFormat.__addLocaleData === 'function') {
  Intl.DateTimeFormat.__addLocaleData({
    "data": {
      "am": "နံနက်",
      "pm": "ညနေ",
      "weekday": {
        "narrow": ["တ", "တ", "အ", "ဗ", "က", "သ", "စ"],
        "short": ["တနင်္ဂနွေ", "တနင်္လာ", "အင်္ဂါ", "ဗုဒ္ဓဟူး", "ကြာသပတေး", "သောကြာ", "စနေ"],
        "long": ["တနင်္ဂနွေ", "တနင်္လာ", "အင်္ဂါ", "ဗုဒ္ဓဟူး", "ကြာသပတေး", "သောကြာ", "စနေ"]
      },
      "era": {
        "narrow": {
          "BC": "ဘီစီ",
          "AD": "အဒေီ"
        },
        "short": {
          "BC": "ဘီစီ",
          "AD": "အဒေီ"
        },
        "long": {
          "BC": "ခရစ်တော် မပေါ်မီနှစ်",
          "AD": "ခရစ်နှစ်"
        }
      },
      "month": {
        "narrow": ["ဇ", "ဖ", "မ", "ဧ", "မ", "ဇ", "ဇ", "ဩ", "စ", "အ", "န", "ဒ"],
        "short": ["ဇန်", "ဖေ", "မတ်", "ဧ", "မေ", "ဇွန်", "ဇူ", "ဩ", "စက်", "အောက်", "နို", "ဒီ"],
        "long": ["ဇန်နဝါရီ", "ဖေဖော်ဝါရီ", "မတ်", "ဧပြီ", "မေ", "ဇွန်", "ဇူလိုင်", "ဩဂုတ်", "စက်တင်ဘာ", "အောက်တိုဘာ", "နိုဝင်ဘာ", "ဒီဇင်ဘာ"]
      },
      "timeZoneName": {
        "Asia/Kabul": {
          "long": ["အာဖဂန်နစ္စတန် အချိန်", "အာဖဂန်နစ္စတန် အချိန်"]
        },
        "Africa/Maputo": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Bujumbura": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Gaborone": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Lubumbashi": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Blantyre": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Kigali": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Lusaka": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Harare": {
          "long": ["အလယ်အာဖရိက အချိန်", "အလယ်အာဖရိက အချိန်"]
        },
        "Africa/Nairobi": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Africa/Djibouti": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Africa/Asmera": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Africa/Addis_Ababa": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Indian/Comoro": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Indian/Antananarivo": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Africa/Mogadishu": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Africa/Dar_es_Salaam": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Africa/Kampala": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Indian/Mayotte": {
          "long": ["အရှေ့အာဖရိက အချိန်", "အရှေ့အာဖရိက အချိန်"]
        },
        "Africa/Johannesburg": {
          "long": ["တောင်အာဖရိက အချိန်", "တောင်အာဖရိက အချိန်"]
        },
        "Africa/Maseru": {
          "long": ["တောင်အာဖရိက အချိန်", "တောင်အာဖရိက အချိန်"]
        },
        "Africa/Mbabane": {
          "long": ["တောင်အာဖရိက အချိန်", "တောင်အာဖရိက အချိန်"]
        },
        "Africa/Lagos": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Luanda": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Porto-Novo": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Kinshasa": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Bangui": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Brazzaville": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Douala": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Libreville": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Malabo": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Niamey": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Africa/Ndjamena": {
          "long": ["အနောက်အာဖရိက စံတော်ချိန်", "အနောက်အာဖရိက နွေရာသီ အချိန်"]
        },
        "Asia/Aqtobe": {
          "long": ["အနောက်ကာဇက်စတန် အချိန်", "အနောက်ကာဇက်စတန် အချိန်"]
        },
        "America/Juneau": {
          "long": ["အလာစကာ စံတော်ချိန်", "အလာစကာ နွေရာသီ စံတော်ချိန်"]
        },
        "Asia/Almaty": {
          "long": ["အရှေ့ကာဇက်စတန် အချိန်", "အရှေ့ကာဇက်စတန် အချိန်"]
        },
        "America/Manaus": {
          "long": ["အမေဇုံ စံတော်ချိန်", "အမေဇုံ နွေရာသီအချိန်"]
        },
        "America/Chicago": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Belize": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Winnipeg": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Costa_Rica": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Guatemala": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Tegucigalpa": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Mexico_City": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/El_Salvador": {
          "long": ["အလယ်ပိုင်းစံတော်ချိန်", "အလယ်ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/New_York": {
          "long": ["အရှေ့ပိုင်းစံတော်ချိန်", "အရှေ့ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Nassau": {
          "long": ["အရှေ့ပိုင်းစံတော်ချိန်", "အရှေ့ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Toronto": {
          "long": ["အရှေ့ပိုင်းစံတော်ချိန်", "အရှေ့ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Port-au-Prince": {
          "long": ["အရှေ့ပိုင်းစံတော်ချိန်", "အရှေ့ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Jamaica": {
          "long": ["အရှေ့ပိုင်းစံတော်ချိန်", "အရှေ့ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Cayman": {
          "long": ["အရှေ့ပိုင်းစံတော်ချိန်", "အရှေ့ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Panama": {
          "long": ["အရှေ့ပိုင်းစံတော်ချိန်", "အရှေ့ပိုင်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Denver": {
          "long": ["တောင်တန်းစံတော်ချိန်", "တောင်တန်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Edmonton": {
          "long": ["တောင်တန်းစံတော်ချိန်", "တောင်တန်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Hermosillo": {
          "long": ["တောင်တန်းစံတော်ချိန်", "တောင်တန်း နွေရာသီစံတော်ချိန်"]
        },
        "America/Los_Angeles": {
          "long": ["ပစိဖိတ်စံတော်ချိန်", "ပစိဖိတ် နွေရာသီစံတော်ချိန်"]
        },
        "America/Vancouver": {
          "long": ["ပစိဖိတ်စံတော်ချိန်", "ပစိဖိတ် နွေရာသီစံတော်ချိန်"]
        },
        "America/Tijuana": {
          "long": ["ပစိဖိတ်စံတော်ချိန်", "ပစိဖိတ် နွေရာသီစံတော်ချိန်"]
        },
        "Pacific/Apia": {
          "long": ["အပီယာ စံတော်ချိန်", "အပီယာ နွေရာသီ အချိန်"]
        },
        "Asia/Riyadh": {
          "long": ["အာရေဗျ စံတော်ချိန်", "အာရေဗျ နွေရာသီ အချိန်"]
        },
        "Asia/Bahrain": {
          "long": ["အာရေဗျ စံတော်ချိန်", "အာရေဗျ နွေရာသီ အချိန်"]
        },
        "Asia/Baghdad": {
          "long": ["အာရေဗျ စံတော်ချိန်", "အာရေဗျ နွေရာသီ အချိန်"]
        },
        "Asia/Kuwait": {
          "long": ["အာရေဗျ စံတော်ချိန်", "အာရေဗျ နွေရာသီ အချိန်"]
        },
        "Asia/Qatar": {
          "long": ["အာရေဗျ စံတော်ချိန်", "အာရေဗျ နွေရာသီ အချိန်"]
        },
        "Asia/Aden": {
          "long": ["အာရေဗျ စံတော်ချိန်", "အာရေဗျ နွေရာသီ အချိန်"]
        },
        "America/Buenos_Aires": {
          "long": ["အာဂျင်တီးနား စံတော်ချိန်", "အာဂျင်တီးနား နွေရာသီအချိန်"]
        },
        "America/Argentina/San_Luis": {
          "long": ["အနောက် အာဂျင်တီးနား စံတော်ချိန်", "အနောက် အာဂျင်တီးနား နွေရာသီ အချိန်"]
        },
        "Asia/Ashgabat": {
          "long": ["တာ့ခ်မင်နစ္စတန် စံတော်ချိန်", "တာ့ခ်မင်နစ္စတန် နွေရာသီ အချိန်"]
        },
        "America/Halifax": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Antigua": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Anguilla": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Aruba": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Barbados": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "Atlantic/Bermuda": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Kralendijk": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Curacao": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Dominica": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Grenada": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Thule": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Guadeloupe": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/St_Kitts": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/St_Lucia": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Marigot": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Martinique": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Montserrat": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Puerto_Rico": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Lower_Princes": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Port_of_Spain": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/St_Vincent": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Tortola": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "America/St_Thomas": {
          "long": ["အတ္တလန်တစ် စံတော်ချိန်", "အတ္တလန်တစ် နွေရာသီ စံတော်ချိန်"]
        },
        "Australia/Adelaide": {
          "long": ["ဩစတြေးလျ အလယ်ပိုင်း စံတော်ချိန်", "ဩစတြေးလျ အလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Australia/Eucla": {
          "long": ["သြစတြေးလျား အနောက်အလယ်ပိုင်း စံတော်ချိန်", "သြစတြေးလျား အနောက်အလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Australia/Sydney": {
          "long": ["အရှေ့ဩစတြေးလျ စံတော်ချိန်", "အရှေ့ဩစတြေးလျ နွေရာသီ အချိန်"]
        },
        "Australia/Perth": {
          "long": ["အနောက်ဩစတြေးလျ စံတော်ချိန်", "ဩစတြေးလျ နွေရာသီ အချိန်"]
        },
        "Atlantic/Azores": {
          "long": ["အေဇိုးရီးစ် စံတော်ချိန်", "အေဇိုးရီးစ် နွေရာသီ အချိန်"]
        },
        "Asia/Thimphu": {
          "long": ["ဘူတန် အချိန်", "ဘူတန် အချိန်"]
        },
        "America/La_Paz": {
          "long": ["ဘိုလီးဘီးယား အချိန်", "ဘိုလီးဘီးယား အချိန်"]
        },
        "Asia/Kuching": {
          "long": ["မလေးရှား အချိန်", "မလေးရှား အချိန်"]
        },
        "America/Sao_Paulo": {
          "long": ["ဘရာဇီး စံတော်ချိန်", "ဘရာဇီး နွေရာသီ အချိန်"]
        },
        "Europe/London": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Asia/Brunei": {
          "long": ["ဘရူနိုင်း စံတော်ချိန်", "ဘရူနိုင်း စံတော်ချိန်"]
        },
        "Atlantic/Cape_Verde": {
          "long": ["ကိတ်ဗာဒီ စံတော်ချိန်", "ကိတ်ဗာဒီ နွေရာသီ အချိန်"]
        },
        "Pacific/Chatham": {
          "long": ["ချားသမ်စံတော်ချိန်", "ချားသမ် နွေရာသီ အချိန်"]
        },
        "America/Santiago": {
          "long": ["ချီလီ စံတော်ချိန်", "ချီလီ နွေရာသီ အချိန်"]
        },
        "Asia/Shanghai": {
          "long": ["တရုတ် စံတော်ချိန်", "တရုတ် နွေရာသီ အချိန်"]
        },
        "Asia/Choibalsan": {
          "long": ["ချွဲဘော်ဆန်း စံတော်ချိန်", "ချွဲဘော်ဆန်း နွေရာသီ အချိန်"]
        },
        "Indian/Christmas": {
          "long": ["ခရစ်စမတ်ကျွန်း အချိန်", "ခရစ်စမတ်ကျွန်း အချိန်"]
        },
        "Indian/Cocos": {
          "long": ["ကိုကိုးကျွန်း အချိန်", "ကိုကိုးကျွန်း အချိန်"]
        },
        "America/Bogota": {
          "long": ["ကိုလံဘီယာ စံတော်ချိန်", "ကိုလံဘီယာ နွေရာသီ အချိန်"]
        },
        "Pacific/Rarotonga": {
          "long": ["ကွတ်ကျွန်းစု စံတော်ချိန်", "ကွတ်ကျွန်းစု နွေရာသီ အချိန်"]
        },
        "America/Havana": {
          "long": ["ကျူးဘား စံတော်ချိန်", "ကျူးဘား နွေရာသီ စံတော်ချိန်"]
        },
        "Antarctica/Davis": {
          "long": ["ဒေးဗစ် အချိန်", "ဒေးဗစ် အချိန်"]
        },
        "Antarctica/DumontDUrville": {
          "long": ["ဒူးမော့တ် ဒါရ်ဗီးလ် အချိန်", "ဒူးမော့တ် ဒါရ်ဗီးလ် အချိန်"]
        },
        "Asia/Dushanbe": {
          "long": ["တာဂျစ်ကစ္စတန် အချိန်", "တာဂျစ်ကစ္စတန် အချိန်"]
        },
        "America/Paramaribo": {
          "long": ["စူးရီနာမ်အချိန်", "စူးရီနာမ်အချိန်"]
        },
        "Asia/Dili": {
          "long": ["အရှေ့တီမော အချိန်", "အရှေ့တီမော အချိန်"]
        },
        "Pacific/Easter": {
          "long": ["အီစတာကျွန်း စံတော်ချိန်", "အီစတာကျွန်း နွေရာသီ အချိန်"]
        },
        "America/Guayaquil": {
          "long": ["အီကွေဒေါ အချိန်", "အီကွေဒေါ အချိန်"]
        },
        "Europe/Paris": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Andorra": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Tirane": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Vienna": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Sarajevo": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Brussels": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Zurich": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Prague": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Berlin": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Copenhagen": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Madrid": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Gibraltar": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Zagreb": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Budapest": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Rome": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Vaduz": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Luxembourg": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Monaco": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Podgorica": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Skopje": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Malta": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Amsterdam": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Oslo": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Warsaw": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Belgrade": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Stockholm": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Ljubljana": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Arctic/Longyearbyen": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Bratislava": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/San_Marino": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Africa/Tunis": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Vatican": {
          "long": ["ဥရောပအလယ်ပိုင်း စံတော်ချိန်", "ဥရောပအလယ်ပိုင်း နွေရာသီ အချိန်"]
        },
        "Europe/Bucharest": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Europe/Mariehamn": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Europe/Sofia": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Asia/Nicosia": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Africa/Cairo": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Europe/Helsinki": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Europe/Athens": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Asia/Beirut": {
          "long": ["အရှေ့ဥရောပ စံတော်ချိန်", "အရှေ့ဥရောပ နွေရာသီ အချိန်"]
        },
        "Europe/Minsk": {
          "long": ["အရှေ့ဖျား ဥရောပဒေသ အချိန်", "အရှေ့ဖျား ဥရောပဒေသ အချိန်"]
        },
        "Europe/Kaliningrad": {
          "long": ["အရှေ့ဖျား ဥရောပဒေသ အချိန်", "အရှေ့ဖျား ဥရောပဒေသ အချိန်"]
        },
        "Atlantic/Canary": {
          "long": ["အနောက်ဥရောပ စံတော်ချိန်", "အနောက်ဥရောပ နွေရာသီ အချိန်"]
        },
        "Atlantic/Faeroe": {
          "long": ["အနောက်ဥရောပ စံတော်ချိန်", "အနောက်ဥရောပ နွေရာသီ အချိန်"]
        },
        "Atlantic/Stanley": {
          "long": ["ဖော့ကလန်ကျွန်းစု စံတော်ချိန်", "ဖော့ကလန်ကျွန်းစု နွေရာသီ အချိန်"]
        },
        "Pacific/Fiji": {
          "long": ["ဖီဂျီ စံတော်ချိန်", "ဖီဂျီ နွေရာသီ အချိန်"]
        },
        "America/Cayenne": {
          "long": ["ပြင်သစ် ဂီအားနား အချိန်", "ပြင်သစ် ဂီအားနား အချိန်"]
        },
        "Indian/Kerguelen": {
          "long": ["ပြင်သစ်တောင်ပိုင်းနှင့် အန္တာတိတ် အချိန်", "ပြင်သစ်တောင်ပိုင်းနှင့် အန္တာတိတ် အချိန်"]
        },
        "Asia/Bishkek": {
          "long": ["ကာဂျစ္စတန် အချိန်", "ကာဂျစ္စတန် အချိန်"]
        },
        "Pacific/Galapagos": {
          "long": ["ဂါလားပါဂိုးစ် အချိန်", "ဂါလားပါဂိုးစ် အချိန်"]
        },
        "Pacific/Gambier": {
          "long": ["ဂမ်ဘီယာ အချိန်", "ဂမ်ဘီယာ အချိန်"]
        },
        "Pacific/Tarawa": {
          "long": ["ဂီလ်ဘတ်ကျွန်းစု အချိန်", "ဂီလ်ဘတ်ကျွန်းစု အချိန်"]
        },
        "Atlantic/Reykjavik": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Ouagadougou": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Abidjan": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Accra": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Banjul": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Conakry": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Bamako": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Nouakchott": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Atlantic/St_Helena": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Freetown": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Dakar": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "Africa/Lome": {
          "long": ["ဂရင်းနစ် စံတော်ချိန်", "ဂရင်းနစ် စံတော်ချိန်"]
        },
        "America/Scoresbysund": {
          "long": ["အရှေ့ဂရင်းလန်း စံတော်ချိန်", "အရှေ့ဂရင်းလန် နွေရာသီ စံတော်ချိန်"]
        },
        "America/Godthab": {
          "long": ["အနောက် ဂရင်းလန်း စံတော်ချိန်", "အနောက် ဂရင်းလန် နွေရာသီ စံတော်ချိန်"]
        },
        "Asia/Dubai": {
          "long": ["ပင်လယ်ကွေ့ အချိန်", "ပင်လယ်ကွေ့ အချိန်"]
        },
        "Asia/Muscat": {
          "long": ["ပင်လယ်ကွေ့ အချိန်", "ပင်လယ်ကွေ့ အချိန်"]
        },
        "America/Guyana": {
          "long": ["ဂိုင်ယာနာ အချိန်", "ဂိုင်ယာနာ အချိန်"]
        },
        "Pacific/Honolulu": {
          "long": ["ဟာဝိုင်ယီ အယ်လူးရှန်း စံတော်ချိန်", "ဟာဝိုင်ယီ အယ်လူးရှန်း နွေရာသီ စံတော်ချိန်"]
        },
        "Asia/Hong_Kong": {
          "long": ["ဟောင်ကောင် စံတော်ချိန်", "ဟောင်ကောင် နွေရာသီ အချိန်"]
        },
        "Asia/Hovd": {
          "long": ["ဟိုးဗ် စံတော်ချိန်", "ဟိုးဗ် နွေရာသီ အချိန်"]
        },
        "Asia/Calcutta": {
          "long": ["အိန္ဒိယ စံတော်ချိန်", "အိန္ဒိယ စံတော်ချိန်"]
        },
        "Asia/Colombo": {
          "long": ["သီရိလင်္ကာ အချိန်", "သီရိလင်္ကာ အချိန်"]
        },
        "Indian/Chagos": {
          "long": ["အိန္ဒိယသမုဒ္ဒရာ အချိန်", "အိန္ဒိယသမုဒ္ဒရာ အချိန်"]
        },
        "Asia/Bangkok": {
          "long": ["အင်ဒိုချိုင်းနား အချိန်", "အင်ဒိုချိုင်းနား အချိန်"]
        },
        "Asia/Phnom_Penh": {
          "long": ["အင်ဒိုချိုင်းနား အချိန်", "အင်ဒိုချိုင်းနား အချိန်"]
        },
        "Asia/Vientiane": {
          "long": ["အင်ဒိုချိုင်းနား အချိန်", "အင်ဒိုချိုင်းနား အချိန်"]
        },
        "Asia/Makassar": {
          "long": ["အလယ်ပိုင်း အင်ဒိုနီးရှား အချိန်", "အလယ်ပိုင်း အင်ဒိုနီးရှား အချိန်"]
        },
        "Asia/Jayapura": {
          "long": ["အရှေ့ပိုင်း အင်ဒိုနီးရှား အချိန်", "အရှေ့ပိုင်း အင်ဒိုနီးရှား အချိန်"]
        },
        "Asia/Jakarta": {
          "long": ["အနောက်ပိုင်း အင်ဒိုနီးရှား အချိန်", "အနောက်ပိုင်း အင်ဒိုနီးရှား အချိန်"]
        },
        "Asia/Tehran": {
          "long": ["အီရန် စံတော်ချိန်", "အီရန် နွေရာသီ အချိန်"]
        },
        "Asia/Irkutsk": {
          "long": ["အီရူခူတ် စံတော်ချိန်", "အီရူခူတ် နွေရာသီ အချိန်"]
        },
        "Asia/Jerusalem": {
          "long": ["အစ္စရေး စံတော်ချိန်", "အစ္စရေး နွေရာသီ အချိန်"]
        },
        "Asia/Tokyo": {
          "long": ["ဂျပန် စံတော်ချိန်", "ဂျပန် နွေရာသီ အချိန်"]
        },
        "Asia/Karachi": {
          "long": ["ပါကစ္စတန် စံတော်ချိန်", "ပါကစ္စတန် နွေရာသီ အချိန်"]
        },
        "Asia/Seoul": {
          "long": ["ကိုရီးယား စံတော်ချိန်", "ကိုရီးယား နွေရာသီ အချိန်"]
        },
        "Pacific/Kosrae": {
          "long": ["ခိုစ်ရိုင် အချိန်", "ခိုစ်ရိုင် အချိန်"]
        },
        "Asia/Krasnoyarsk": {
          "long": ["ခရာ့စ်နိုရာစ် စံတော်ချိန်", "ခရာ့စ်နိုရာစ် နွေရာသီ အချိန်"]
        },
        "Pacific/Kiritimati": {
          "long": ["လိုင်းကျွန်းစု အချိန်", "လိုင်းကျွန်းစု အချိန်"]
        },
        "Australia/Lord_Howe": {
          "long": ["လော့ဒ်ဟောင် စံတော်ချိန်", "လော့ဒ်ဟောင် နွေရာသီ အချိန်"]
        },
        "Asia/Macau": {
          "long": ["မကာအို စံတော်ချိန်", "မကာအို နွေရာသီ အချိန်"]
        },
        "Antarctica/Macquarie": {
          "long": ["မက်ကွယ်ရီကျွန်း အချိန်", "မက်ကွယ်ရီကျွန်း အချိန်"]
        },
        "Asia/Magadan": {
          "long": ["မာဂါဒန်း စံတော်ချိန်", "မာဂါဒန်း နွေရာသီ အချိန်"]
        },
        "Indian/Maldives": {
          "long": ["မော်လဒိုက် အချိန်", "မော်လဒိုက် အချိန်"]
        },
        "Pacific/Marquesas": {
          "long": ["မာခေးအပ်စ် အချိန်", "မာခေးအပ်စ် အချိန်"]
        },
        "Pacific/Majuro": {
          "long": ["မာရှယ်ကျွန်းစု အချိန်", "မာရှယ်ကျွန်းစု အချိန်"]
        },
        "Indian/Mauritius": {
          "long": ["မောရစ်ရှ စံတော်ချိန်", "မောရစ်ရှ နွေရာသီ အချိန်"]
        },
        "Antarctica/Mawson": {
          "long": ["မော်စွန် အချိန်", "မော်စွန် အချိန်"]
        },
        "America/Santa_Isabel": {
          "long": ["အနောက်တောင် မက္ကဆီကို စံတော်ချိန်", "အနောက်တောင် မက္ကစီကို နွေရာသီ စံတော်ချိန်"]
        },
        "America/Mazatlan": {
          "long": ["မက္ကဆီကန် ပစိဖိတ် စံတော်ချိန်", "မက္ကစီကန် ပစိဖိတ် နွေရာသီ စံတော်ချိန်"]
        },
        "Asia/Ulaanbaatar": {
          "long": ["ဥလန်ဘာတော စံတော်ချိန်", "ဥလန်ဘာတော နွေရာသီ အချိန်"]
        },
        "Europe/Moscow": {
          "long": ["မော်စကို စံတော်ချိန်", "မော်စကို နွေရာသီ အချိန်"]
        },
        "Asia/Rangoon": {
          "long": ["မြန်မာ အချိန်", "မြန်မာ အချိန်"]
        },
        "Pacific/Nauru": {
          "long": ["နာဥူရူ အချိန်", "နာဥူရူ အချိန်"]
        },
        "Asia/Katmandu": {
          "long": ["နီပေါ အချိန်", "နီပေါ အချိန်"]
        },
        "Pacific/Noumea": {
          "long": ["နယူးကာလီဒိုးနီးယား စံတော်ချိန်", "နယူးကာလီဒိုးနီးယား နွေရာသီ အချိန်"]
        },
        "Pacific/Auckland": {
          "long": ["နယူးဇီလန် စံတော်ချိန်", "နယူးဇီလန် နွေရာသီ အချိန်"]
        },
        "Antarctica/McMurdo": {
          "long": ["နယူးဇီလန် စံတော်ချိန်", "နယူးဇီလန် နွေရာသီ အချိန်"]
        },
        "America/St_Johns": {
          "long": ["နယူးဖောင်လန် စံတော်ချိန်", "နယူးဖောင်လန် နွေရာသီ စံတော်ချိန်"]
        },
        "Pacific/Niue": {
          "long": ["နီဥူအေ အချိန်", "နီဥူအေ အချိန်"]
        },
        "Pacific/Norfolk": {
          "long": ["နောဖော့ခ်ကျွန်း စံတော်ချိန်", "နောဖော့ခ်ကျွန်း နွေရာသီ စံတော်ချိန်"]
        },
        "America/Noronha": {
          "long": ["ဖာနန်ဒိုးဒီနိုးရိုးညာ စံတော်ချိန်", "ဖာနန်ဒိုးဒီနိုးရိုးညာ နွေရာသီ အချိန်"]
        },
        "Asia/Novosibirsk": {
          "long": ["နိုဗိုစဲဘီအဲယ်စ် စံတော်ချိန်", "နိုဗိုစဲဘီအဲယ်စ် နွေရာသီ အချိန်"]
        },
        "Asia/Omsk": {
          "long": ["အွမ်းစ်ခ် စံတော်ချိန်", "အွမ်းစ်ခ် နွေရာသီ အချိန်"]
        },
        "Pacific/Palau": {
          "long": ["ပလာအို အချိန်", "ပလာအို အချိန်"]
        },
        "Pacific/Port_Moresby": {
          "long": ["ပါပူအာနယူးဂီနီ အချိန်", "ပါပူအာနယူးဂီနီ အချိန်"]
        },
        "America/Asuncion": {
          "long": ["ပါရာဂွေး စံတော်ချိန်", "ပါရာဂွေး နွေရာသီ အချိန်"]
        },
        "America/Lima": {
          "long": ["ပီရူး စံတော်ချိန်", "ပီရူး နွေရာသီ အချိန်"]
        },
        "Asia/Manila": {
          "long": ["ဖိလစ်ပိုင် စံတော်ချိန်", "ဖိလစ်ပိုင် နွေရာသီ အချိန်"]
        },
        "Pacific/Enderbury": {
          "long": ["ဖီးနစ်ကျွန်းစု အချိန်", "ဖီးနစ်ကျွန်းစု အချိန်"]
        },
        "America/Miquelon": {
          "long": ["စိန့်ပီအဲနှင့်မီခွီလွန်စံတော်ချိန်", "စိန့်ပီအဲနှင့် မီခွီလွန် နွေရာသီ စံတော်ချိန်"]
        },
        "Pacific/Pitcairn": {
          "long": ["ပါတ်ကယ်ရင် အချိန်", "ပါတ်ကယ်ရင် အချိန်"]
        },
        "Pacific/Ponape": {
          "long": ["ဖိုနာဖဲအ် အချိန်", "ဖိုနာဖဲအ် အချိန်"]
        },
        "Asia/Pyongyang": {
          "long": ["ပြုံယန်း အချိန်", "ပြုံယန်း အချိန်"]
        },
        "Indian/Reunion": {
          "long": ["ရီယူနီယံ အချိန်", "ရီယူနီယံ အချိန်"]
        },
        "Antarctica/Rothera": {
          "long": ["ရိုသီရာ အချိန်", "ရိုသီရာ အချိန်"]
        },
        "Asia/Sakhalin": {
          "long": ["ဆာခါလင် စံတော်ချိန်", "ဆာခါလင် နွေရာသီ အချိန်"]
        },
        "Pacific/Pago_Pago": {
          "long": ["ဆမိုအာ စံတော်ချိန်", "ဆမိုးအား နွေရာသီ အချိန်"]
        },
        "Indian/Mahe": {
          "long": ["ဆေးရှဲ အချိန်", "ဆေးရှဲ အချိန်"]
        },
        "Asia/Singapore": {
          "long": ["စင်္ကာပူ အချိန်", "စင်္ကာပူ အချိန်"]
        },
        "Pacific/Guadalcanal": {
          "long": ["ဆော်လမွန်ကျွန်းစု အချိန်", "ဆော်လမွန်ကျွန်းစု အချိန်"]
        },
        "Atlantic/South_Georgia": {
          "long": ["တောင်ဂျော်ဂျီယာ အချိန်", "တောင်ဂျော်ဂျီယာ အချိန်"]
        },
        "Asia/Yekaterinburg": {
          "long": ["ရယ်ခါးတီရင်ဘားခ် စံတော်ချိန်", "ရယ်ခါးတီရင်ဘာခ် နွေရာသီ အချိန်"]
        },
        "Antarctica/Syowa": {
          "long": ["ရှိုဝါ အချိန်", "ရှိုဝါ အချိန်"]
        },
        "Pacific/Tahiti": {
          "long": ["တဟီတီ အချိန်", "တဟီတီ အချိန်"]
        },
        "Asia/Taipei": {
          "long": ["ထိုင်ပေ စံတော်ချိန်", "ထိုင်ပေ နွေရာသီ အချိန်"]
        },
        "Asia/Tashkent": {
          "long": ["ဥဇဘက်ကစ္စတန် စံတော်ချိန်", "ဥဇဘက်ကစ္စတန် နွေရာသီ အချိန်"]
        },
        "Pacific/Fakaofo": {
          "long": ["တိုကီလာဥ အချိန်", "တိုကီလာဥ အချိန်"]
        },
        "Pacific/Tongatapu": {
          "long": ["တွန်ဂါ စံတော်ချိန်", "တွန်ဂါ နွေရာသီ အချိန်"]
        },
        "Pacific/Truk": {
          "long": ["ချုခ် အချိန်", "ချုခ် အချိန်"]
        },
        "Pacific/Funafuti": {
          "long": ["တူဗားလူ အချိန်", "တူဗားလူ အချိန်"]
        },
        "America/Montevideo": {
          "long": ["ဥရုဂွေး စံတော်ချိန်", "ဥရုဂွေး နွေရာသီ အချိန်"]
        },
        "Pacific/Efate": {
          "long": ["ဗနွားတူ စံတော်ချိန်", "ဗနွားတူ နွေရာသီ အချိန်"]
        },
        "America/Caracas": {
          "long": ["ဗင်နီဇွဲလား အချိန်", "ဗင်နီဇွဲလား အချိန်"]
        },
        "Asia/Vladivostok": {
          "long": ["ဗလာဒီဗော့စတော့ခ် စံတော်ချိန်", "ဗလာဒီဗော့စတော့ခ် နွေရာသီ အချိန်"]
        },
        "Europe/Volgograd": {
          "long": ["ဗိုလ်ဂိုဂရက် စံတော်ချိန်", "ဗိုဂိုဂရက် နွေရာသီ အချိန်"]
        },
        "Antarctica/Vostok": {
          "long": ["ဗိုစ်တိုခ် အချိန်", "ဗိုစ်တိုခ် အချိန်"]
        },
        "Pacific/Wake": {
          "long": ["ဝိတ်ခ်ကျွန်း အချိန်", "ဝိတ်ခ်ကျွန်း အချိန်"]
        },
        "Pacific/Wallis": {
          "long": ["ဝေါလီစ်နှင့် ဖူကျူနာ အချိန်", "ဝေါလီစ်နှင့် ဖူကျူနာ အချိန်"]
        },
        "Asia/Yakutsk": {
          "long": ["ယူခူးတ်စ် စံတော်ချိန်", "ယူခူးတ်စ် နွေရာသီ အချိန်"]
        },
        "America/Whitehorse": {
          "long": ["ယူကွန်း အချိန်", "ယူကွန်း အချိန်"]
        },
        "UTC": {
          "long": ["ညှိထားသည့် ကမ္ဘာ့ စံတော်ချိန်", "ညှိထားသည့် ကမ္ဘာ့ စံတော်ချိန်"],
          "short": ["UTC", "UTC"]
        }
      },
      "gmtFormat": "GMT{0}",
      "hourFormat": "+HH:mm;-HH:mm",
      "dateFormat": {
        "full": "y၊ MMMM d၊ EEEE",
        "long": "y၊ MMMM d",
        "medium": "y၊ MMM d",
        "short": "d/M/yy"
      },
      "timeFormat": {
        "full": "zzzz HH:mm:ss",
        "long": "z HH:mm:ss",
        "medium": "H:mm:ss",
        "short": "H:mm"
      },
      "dateTimeFormat": {
        "full": "{1} {0}",
        "long": "{1} {0}",
        "medium": "{1} {0}",
        "short": "{1} {0}"
      },
      "formats": {
        "gregory": {
          "Bh": "B h",
          "Bhm": "B h:mm",
          "Bhms": "B h:mm:ss",
          "d": "d",
          "E": "ccc",
          "EBhm": "E B h:mm",
          "EBhms": "E B h:mm:ss",
          "Ed": "d ရက် E",
          "Ehm": "E B h:mm",
          "EHm": "E HH:mm",
          "Ehms": "E B h:mm:ss",
          "EHms": "E HH:mm:ss",
          "Gy": "G y",
          "GyMd": "G y/M/d",
          "GyMMM": "G y MMM",
          "GyMMMd": "G y၊ MMM d",
          "GyMMMEd": "G y၊ MMM d၊ E",
          "h": "B h",
          "H": "HH",
          "hm": "B h:mm",
          "Hm": "HH:mm",
          "hms": "B h:mm:ss",
          "Hms": "HH:mm:ss",
          "hmsv": "v a h:mm:ss",
          "Hmsv": "v HH:mm:ss",
          "hmv": "v a h:mm",
          "Hmv": "v HH:mm",
          "M": "L",
          "Md": "d/M",
          "MEd": "d/M၊ E",
          "MMM": "LLL",
          "MMMd": "d MMM",
          "MMMEd": "MMM d၊ E",
          "MMMMd": "MMMM d",
          "MMMMEd": "MMMM d ရက် E",
          "ms": "mm:ss",
          "y": "y",
          "yM": "M/y",
          "yMd": "d/M/y",
          "yMEd": "d/M/y၊ E",
          "yMMM": "MMM y",
          "yMMMd": "y၊ MMM d",
          "yMMMEd": "y၊ MMM d၊ E",
          "yMMMM": "y MMMM",
          "y၊ MMMM d၊ EEEE": "y၊ MMMM d၊ EEEE",
          "y၊ MMMM d": "y၊ MMMM d",
          "y၊ MMM d": "y၊ MMM d",
          "d/M/yy": "d/M/yy",
          "zzzz HH:mm:ss": "zzzz HH:mm:ss",
          "z HH:mm:ss": "z HH:mm:ss",
          "H:mm:ss": "H:mm:ss",
          "H:mm": "H:mm",
          "y၊ MMMM d၊ EEEE zzzz HH:mm:ss": "y၊ MMMM d၊ EEEE zzzz HH:mm:ss",
          "y၊ MMMM d zzzz HH:mm:ss": "y၊ MMMM d zzzz HH:mm:ss",
          "y၊ MMM d zzzz HH:mm:ss": "y၊ MMM d zzzz HH:mm:ss",
          "d/M/yy zzzz HH:mm:ss": "d/M/yy zzzz HH:mm:ss",
          "d zzzz HH:mm:ss": "d zzzz HH:mm:ss",
          "E zzzz HH:mm:ss": "ccc zzzz HH:mm:ss",
          "Ed zzzz HH:mm:ss": "d ရက် E zzzz HH:mm:ss",
          "Gy zzzz HH:mm:ss": "G y zzzz HH:mm:ss",
          "GyMd zzzz HH:mm:ss": "G y/M/d zzzz HH:mm:ss",
          "GyMMM zzzz HH:mm:ss": "G y MMM zzzz HH:mm:ss",
          "GyMMMd zzzz HH:mm:ss": "G y၊ MMM d zzzz HH:mm:ss",
          "GyMMMEd zzzz HH:mm:ss": "G y၊ MMM d၊ E zzzz HH:mm:ss",
          "M zzzz HH:mm:ss": "L zzzz HH:mm:ss",
          "Md zzzz HH:mm:ss": "d/M zzzz HH:mm:ss",
          "MEd zzzz HH:mm:ss": "d/M၊ E zzzz HH:mm:ss",
          "MMM zzzz HH:mm:ss": "LLL zzzz HH:mm:ss",
          "MMMd zzzz HH:mm:ss": "d MMM zzzz HH:mm:ss",
          "MMMEd zzzz HH:mm:ss": "MMM d၊ E zzzz HH:mm:ss",
          "MMMMd zzzz HH:mm:ss": "MMMM d zzzz HH:mm:ss",
          "MMMMEd zzzz HH:mm:ss": "MMMM d ရက် E zzzz HH:mm:ss",
          "y zzzz HH:mm:ss": "y zzzz HH:mm:ss",
          "yM zzzz HH:mm:ss": "M/y zzzz HH:mm:ss",
          "yMd zzzz HH:mm:ss": "d/M/y zzzz HH:mm:ss",
          "yMEd zzzz HH:mm:ss": "d/M/y၊ E zzzz HH:mm:ss",
          "yMMM zzzz HH:mm:ss": "MMM y zzzz HH:mm:ss",
          "yMMMd zzzz HH:mm:ss": "y၊ MMM d zzzz HH:mm:ss",
          "yMMMEd zzzz HH:mm:ss": "y၊ MMM d၊ E zzzz HH:mm:ss",
          "yMMMM zzzz HH:mm:ss": "y MMMM zzzz HH:mm:ss",
          "y၊ MMMM d၊ EEEE z HH:mm:ss": "y၊ MMMM d၊ EEEE z HH:mm:ss",
          "y၊ MMMM d z HH:mm:ss": "y၊ MMMM d z HH:mm:ss",
          "y၊ MMM d z HH:mm:ss": "y၊ MMM d z HH:mm:ss",
          "d/M/yy z HH:mm:ss": "d/M/yy z HH:mm:ss",
          "d z HH:mm:ss": "d z HH:mm:ss",
          "E z HH:mm:ss": "ccc z HH:mm:ss",
          "Ed z HH:mm:ss": "d ရက် E z HH:mm:ss",
          "Gy z HH:mm:ss": "G y z HH:mm:ss",
          "GyMd z HH:mm:ss": "G y/M/d z HH:mm:ss",
          "GyMMM z HH:mm:ss": "G y MMM z HH:mm:ss",
          "GyMMMd z HH:mm:ss": "G y၊ MMM d z HH:mm:ss",
          "GyMMMEd z HH:mm:ss": "G y၊ MMM d၊ E z HH:mm:ss",
          "M z HH:mm:ss": "L z HH:mm:ss",
          "Md z HH:mm:ss": "d/M z HH:mm:ss",
          "MEd z HH:mm:ss": "d/M၊ E z HH:mm:ss",
          "MMM z HH:mm:ss": "LLL z HH:mm:ss",
          "MMMd z HH:mm:ss": "d MMM z HH:mm:ss",
          "MMMEd z HH:mm:ss": "MMM d၊ E z HH:mm:ss",
          "MMMMd z HH:mm:ss": "MMMM d z HH:mm:ss",
          "MMMMEd z HH:mm:ss": "MMMM d ရက် E z HH:mm:ss",
          "y z HH:mm:ss": "y z HH:mm:ss",
          "yM z HH:mm:ss": "M/y z HH:mm:ss",
          "yMd z HH:mm:ss": "d/M/y z HH:mm:ss",
          "yMEd z HH:mm:ss": "d/M/y၊ E z HH:mm:ss",
          "yMMM z HH:mm:ss": "MMM y z HH:mm:ss",
          "yMMMd z HH:mm:ss": "y၊ MMM d z HH:mm:ss",
          "yMMMEd z HH:mm:ss": "y၊ MMM d၊ E z HH:mm:ss",
          "yMMMM z HH:mm:ss": "y MMMM z HH:mm:ss",
          "y၊ MMMM d၊ EEEE H:mm:ss": "y၊ MMMM d၊ EEEE H:mm:ss",
          "y၊ MMMM d H:mm:ss": "y၊ MMMM d H:mm:ss",
          "y၊ MMM d H:mm:ss": "y၊ MMM d H:mm:ss",
          "d/M/yy H:mm:ss": "d/M/yy H:mm:ss",
          "d H:mm:ss": "d H:mm:ss",
          "E H:mm:ss": "ccc H:mm:ss",
          "Ed H:mm:ss": "d ရက် E H:mm:ss",
          "Gy H:mm:ss": "G y H:mm:ss",
          "GyMd H:mm:ss": "G y/M/d H:mm:ss",
          "GyMMM H:mm:ss": "G y MMM H:mm:ss",
          "GyMMMd H:mm:ss": "G y၊ MMM d H:mm:ss",
          "GyMMMEd H:mm:ss": "G y၊ MMM d၊ E H:mm:ss",
          "M H:mm:ss": "L H:mm:ss",
          "Md H:mm:ss": "d/M H:mm:ss",
          "MEd H:mm:ss": "d/M၊ E H:mm:ss",
          "MMM H:mm:ss": "LLL H:mm:ss",
          "MMMd H:mm:ss": "d MMM H:mm:ss",
          "MMMEd H:mm:ss": "MMM d၊ E H:mm:ss",
          "MMMMd H:mm:ss": "MMMM d H:mm:ss",
          "MMMMEd H:mm:ss": "MMMM d ရက် E H:mm:ss",
          "y H:mm:ss": "y H:mm:ss",
          "yM H:mm:ss": "M/y H:mm:ss",
          "yMd H:mm:ss": "d/M/y H:mm:ss",
          "yMEd H:mm:ss": "d/M/y၊ E H:mm:ss",
          "yMMM H:mm:ss": "MMM y H:mm:ss",
          "yMMMd H:mm:ss": "y၊ MMM d H:mm:ss",
          "yMMMEd H:mm:ss": "y၊ MMM d၊ E H:mm:ss",
          "yMMMM H:mm:ss": "y MMMM H:mm:ss",
          "y၊ MMMM d၊ EEEE H:mm": "y၊ MMMM d၊ EEEE H:mm",
          "y၊ MMMM d H:mm": "y၊ MMMM d H:mm",
          "y၊ MMM d H:mm": "y၊ MMM d H:mm",
          "d/M/yy H:mm": "d/M/yy H:mm",
          "d H:mm": "d H:mm",
          "E H:mm": "ccc H:mm",
          "Ed H:mm": "d ရက် E H:mm",
          "Gy H:mm": "G y H:mm",
          "GyMd H:mm": "G y/M/d H:mm",
          "GyMMM H:mm": "G y MMM H:mm",
          "GyMMMd H:mm": "G y၊ MMM d H:mm",
          "GyMMMEd H:mm": "G y၊ MMM d၊ E H:mm",
          "M H:mm": "L H:mm",
          "Md H:mm": "d/M H:mm",
          "MEd H:mm": "d/M၊ E H:mm",
          "MMM H:mm": "LLL H:mm",
          "MMMd H:mm": "d MMM H:mm",
          "MMMEd H:mm": "MMM d၊ E H:mm",
          "MMMMd H:mm": "MMMM d H:mm",
          "MMMMEd H:mm": "MMMM d ရက် E H:mm",
          "y H:mm": "y H:mm",
          "yM H:mm": "M/y H:mm",
          "yMd H:mm": "d/M/y H:mm",
          "yMEd H:mm": "d/M/y၊ E H:mm",
          "yMMM H:mm": "MMM y H:mm",
          "yMMMd H:mm": "y၊ MMM d H:mm",
          "yMMMEd H:mm": "y၊ MMM d၊ E H:mm",
          "yMMMM H:mm": "y MMMM H:mm",
          "y၊ MMMM d၊ EEEE Bh": "y၊ MMMM d၊ EEEE B h",
          "y၊ MMMM d Bh": "y၊ MMMM d B h",
          "y၊ MMM d Bh": "y၊ MMM d B h",
          "d/M/yy Bh": "d/M/yy B h",
          "d Bh": "d B h",
          "E Bh": "ccc B h",
          "Ed Bh": "d ရက် E B h",
          "Gy Bh": "G y B h",
          "GyMd Bh": "G y/M/d B h",
          "GyMMM Bh": "G y MMM B h",
          "GyMMMd Bh": "G y၊ MMM d B h",
          "GyMMMEd Bh": "G y၊ MMM d၊ E B h",
          "M Bh": "L B h",
          "Md Bh": "d/M B h",
          "MEd Bh": "d/M၊ E B h",
          "MMM Bh": "LLL B h",
          "MMMd Bh": "d MMM B h",
          "MMMEd Bh": "MMM d၊ E B h",
          "MMMMd Bh": "MMMM d B h",
          "MMMMEd Bh": "MMMM d ရက် E B h",
          "y Bh": "y B h",
          "yM Bh": "M/y B h",
          "yMd Bh": "d/M/y B h",
          "yMEd Bh": "d/M/y၊ E B h",
          "yMMM Bh": "MMM y B h",
          "yMMMd Bh": "y၊ MMM d B h",
          "yMMMEd Bh": "y၊ MMM d၊ E B h",
          "yMMMM Bh": "y MMMM B h",
          "y၊ MMMM d၊ EEEE Bhm": "y၊ MMMM d၊ EEEE B h:mm",
          "y၊ MMMM d Bhm": "y၊ MMMM d B h:mm",
          "y၊ MMM d Bhm": "y၊ MMM d B h:mm",
          "d/M/yy Bhm": "d/M/yy B h:mm",
          "d Bhm": "d B h:mm",
          "E Bhm": "ccc B h:mm",
          "Ed Bhm": "d ရက် E B h:mm",
          "Gy Bhm": "G y B h:mm",
          "GyMd Bhm": "G y/M/d B h:mm",
          "GyMMM Bhm": "G y MMM B h:mm",
          "GyMMMd Bhm": "G y၊ MMM d B h:mm",
          "GyMMMEd Bhm": "G y၊ MMM d၊ E B h:mm",
          "M Bhm": "L B h:mm",
          "Md Bhm": "d/M B h:mm",
          "MEd Bhm": "d/M၊ E B h:mm",
          "MMM Bhm": "LLL B h:mm",
          "MMMd Bhm": "d MMM B h:mm",
          "MMMEd Bhm": "MMM d၊ E B h:mm",
          "MMMMd Bhm": "MMMM d B h:mm",
          "MMMMEd Bhm": "MMMM d ရက် E B h:mm",
          "y Bhm": "y B h:mm",
          "yM Bhm": "M/y B h:mm",
          "yMd Bhm": "d/M/y B h:mm",
          "yMEd Bhm": "d/M/y၊ E B h:mm",
          "yMMM Bhm": "MMM y B h:mm",
          "yMMMd Bhm": "y၊ MMM d B h:mm",
          "yMMMEd Bhm": "y၊ MMM d၊ E B h:mm",
          "yMMMM Bhm": "y MMMM B h:mm",
          "y၊ MMMM d၊ EEEE Bhms": "y၊ MMMM d၊ EEEE B h:mm:ss",
          "y၊ MMMM d Bhms": "y၊ MMMM d B h:mm:ss",
          "y၊ MMM d Bhms": "y၊ MMM d B h:mm:ss",
          "d/M/yy Bhms": "d/M/yy B h:mm:ss",
          "d Bhms": "d B h:mm:ss",
          "E Bhms": "ccc B h:mm:ss",
          "Ed Bhms": "d ရက် E B h:mm:ss",
          "Gy Bhms": "G y B h:mm:ss",
          "GyMd Bhms": "G y/M/d B h:mm:ss",
          "GyMMM Bhms": "G y MMM B h:mm:ss",
          "GyMMMd Bhms": "G y၊ MMM d B h:mm:ss",
          "GyMMMEd Bhms": "G y၊ MMM d၊ E B h:mm:ss",
          "M Bhms": "L B h:mm:ss",
          "Md Bhms": "d/M B h:mm:ss",
          "MEd Bhms": "d/M၊ E B h:mm:ss",
          "MMM Bhms": "LLL B h:mm:ss",
          "MMMd Bhms": "d MMM B h:mm:ss",
          "MMMEd Bhms": "MMM d၊ E B h:mm:ss",
          "MMMMd Bhms": "MMMM d B h:mm:ss",
          "MMMMEd Bhms": "MMMM d ရက် E B h:mm:ss",
          "y Bhms": "y B h:mm:ss",
          "yM Bhms": "M/y B h:mm:ss",
          "yMd Bhms": "d/M/y B h:mm:ss",
          "yMEd Bhms": "d/M/y၊ E B h:mm:ss",
          "yMMM Bhms": "MMM y B h:mm:ss",
          "yMMMd Bhms": "y၊ MMM d B h:mm:ss",
          "yMMMEd Bhms": "y၊ MMM d၊ E B h:mm:ss",
          "yMMMM Bhms": "y MMMM B h:mm:ss",
          "y၊ MMMM d၊ EEEE h": "y၊ MMMM d၊ EEEE B h",
          "y၊ MMMM d h": "y၊ MMMM d B h",
          "y၊ MMM d h": "y၊ MMM d B h",
          "d/M/yy h": "d/M/yy B h",
          "d h": "d B h",
          "E h": "ccc B h",
          "Ed h": "d ရက် E B h",
          "Gy h": "G y B h",
          "GyMd h": "G y/M/d B h",
          "GyMMM h": "G y MMM B h",
          "GyMMMd h": "G y၊ MMM d B h",
          "GyMMMEd h": "G y၊ MMM d၊ E B h",
          "M h": "L B h",
          "Md h": "d/M B h",
          "MEd h": "d/M၊ E B h",
          "MMM h": "LLL B h",
          "MMMd h": "d MMM B h",
          "MMMEd h": "MMM d၊ E B h",
          "MMMMd h": "MMMM d B h",
          "MMMMEd h": "MMMM d ရက် E B h",
          "y h": "y B h",
          "yM h": "M/y B h",
          "yMd h": "d/M/y B h",
          "yMEd h": "d/M/y၊ E B h",
          "yMMM h": "MMM y B h",
          "yMMMd h": "y၊ MMM d B h",
          "yMMMEd h": "y၊ MMM d၊ E B h",
          "yMMMM h": "y MMMM B h",
          "y၊ MMMM d၊ EEEE H": "y၊ MMMM d၊ EEEE HH",
          "y၊ MMMM d H": "y၊ MMMM d HH",
          "y၊ MMM d H": "y၊ MMM d HH",
          "d/M/yy H": "d/M/yy HH",
          "d H": "d HH",
          "E H": "ccc HH",
          "Ed H": "d ရက် E HH",
          "Gy H": "G y HH",
          "GyMd H": "G y/M/d HH",
          "GyMMM H": "G y MMM HH",
          "GyMMMd H": "G y၊ MMM d HH",
          "GyMMMEd H": "G y၊ MMM d၊ E HH",
          "M H": "L HH",
          "Md H": "d/M HH",
          "MEd H": "d/M၊ E HH",
          "MMM H": "LLL HH",
          "MMMd H": "d MMM HH",
          "MMMEd H": "MMM d၊ E HH",
          "MMMMd H": "MMMM d HH",
          "MMMMEd H": "MMMM d ရက် E HH",
          "y H": "y HH",
          "yM H": "M/y HH",
          "yMd H": "d/M/y HH",
          "yMEd H": "d/M/y၊ E HH",
          "yMMM H": "MMM y HH",
          "yMMMd H": "y၊ MMM d HH",
          "yMMMEd H": "y၊ MMM d၊ E HH",
          "yMMMM H": "y MMMM HH",
          "y၊ MMMM d၊ EEEE hm": "y၊ MMMM d၊ EEEE B h:mm",
          "y၊ MMMM d hm": "y၊ MMMM d B h:mm",
          "y၊ MMM d hm": "y၊ MMM d B h:mm",
          "d/M/yy hm": "d/M/yy B h:mm",
          "d hm": "d B h:mm",
          "E hm": "ccc B h:mm",
          "Ed hm": "d ရက် E B h:mm",
          "Gy hm": "G y B h:mm",
          "GyMd hm": "G y/M/d B h:mm",
          "GyMMM hm": "G y MMM B h:mm",
          "GyMMMd hm": "G y၊ MMM d B h:mm",
          "GyMMMEd hm": "G y၊ MMM d၊ E B h:mm",
          "M hm": "L B h:mm",
          "Md hm": "d/M B h:mm",
          "MEd hm": "d/M၊ E B h:mm",
          "MMM hm": "LLL B h:mm",
          "MMMd hm": "d MMM B h:mm",
          "MMMEd hm": "MMM d၊ E B h:mm",
          "MMMMd hm": "MMMM d B h:mm",
          "MMMMEd hm": "MMMM d ရက် E B h:mm",
          "y hm": "y B h:mm",
          "yM hm": "M/y B h:mm",
          "yMd hm": "d/M/y B h:mm",
          "yMEd hm": "d/M/y၊ E B h:mm",
          "yMMM hm": "MMM y B h:mm",
          "yMMMd hm": "y၊ MMM d B h:mm",
          "yMMMEd hm": "y၊ MMM d၊ E B h:mm",
          "yMMMM hm": "y MMMM B h:mm",
          "y၊ MMMM d၊ EEEE Hm": "y၊ MMMM d၊ EEEE HH:mm",
          "y၊ MMMM d Hm": "y၊ MMMM d HH:mm",
          "y၊ MMM d Hm": "y၊ MMM d HH:mm",
          "d/M/yy Hm": "d/M/yy HH:mm",
          "d Hm": "d HH:mm",
          "E Hm": "ccc HH:mm",
          "Ed Hm": "d ရက် E HH:mm",
          "Gy Hm": "G y HH:mm",
          "GyMd Hm": "G y/M/d HH:mm",
          "GyMMM Hm": "G y MMM HH:mm",
          "GyMMMd Hm": "G y၊ MMM d HH:mm",
          "GyMMMEd Hm": "G y၊ MMM d၊ E HH:mm",
          "M Hm": "L HH:mm",
          "Md Hm": "d/M HH:mm",
          "MEd Hm": "d/M၊ E HH:mm",
          "MMM Hm": "LLL HH:mm",
          "MMMd Hm": "d MMM HH:mm",
          "MMMEd Hm": "MMM d၊ E HH:mm",
          "MMMMd Hm": "MMMM d HH:mm",
          "MMMMEd Hm": "MMMM d ရက် E HH:mm",
          "y Hm": "y HH:mm",
          "yM Hm": "M/y HH:mm",
          "yMd Hm": "d/M/y HH:mm",
          "yMEd Hm": "d/M/y၊ E HH:mm",
          "yMMM Hm": "MMM y HH:mm",
          "yMMMd Hm": "y၊ MMM d HH:mm",
          "yMMMEd Hm": "y၊ MMM d၊ E HH:mm",
          "yMMMM Hm": "y MMMM HH:mm",
          "y၊ MMMM d၊ EEEE hms": "y၊ MMMM d၊ EEEE B h:mm:ss",
          "y၊ MMMM d hms": "y၊ MMMM d B h:mm:ss",
          "y၊ MMM d hms": "y၊ MMM d B h:mm:ss",
          "d/M/yy hms": "d/M/yy B h:mm:ss",
          "d hms": "d B h:mm:ss",
          "E hms": "ccc B h:mm:ss",
          "Ed hms": "d ရက် E B h:mm:ss",
          "Gy hms": "G y B h:mm:ss",
          "GyMd hms": "G y/M/d B h:mm:ss",
          "GyMMM hms": "G y MMM B h:mm:ss",
          "GyMMMd hms": "G y၊ MMM d B h:mm:ss",
          "GyMMMEd hms": "G y၊ MMM d၊ E B h:mm:ss",
          "M hms": "L B h:mm:ss",
          "Md hms": "d/M B h:mm:ss",
          "MEd hms": "d/M၊ E B h:mm:ss",
          "MMM hms": "LLL B h:mm:ss",
          "MMMd hms": "d MMM B h:mm:ss",
          "MMMEd hms": "MMM d၊ E B h:mm:ss",
          "MMMMd hms": "MMMM d B h:mm:ss",
          "MMMMEd hms": "MMMM d ရက် E B h:mm:ss",
          "y hms": "y B h:mm:ss",
          "yM hms": "M/y B h:mm:ss",
          "yMd hms": "d/M/y B h:mm:ss",
          "yMEd hms": "d/M/y၊ E B h:mm:ss",
          "yMMM hms": "MMM y B h:mm:ss",
          "yMMMd hms": "y၊ MMM d B h:mm:ss",
          "yMMMEd hms": "y၊ MMM d၊ E B h:mm:ss",
          "yMMMM hms": "y MMMM B h:mm:ss",
          "y၊ MMMM d၊ EEEE Hms": "y၊ MMMM d၊ EEEE HH:mm:ss",
          "y၊ MMMM d Hms": "y၊ MMMM d HH:mm:ss",
          "y၊ MMM d Hms": "y၊ MMM d HH:mm:ss",
          "d/M/yy Hms": "d/M/yy HH:mm:ss",
          "d Hms": "d HH:mm:ss",
          "E Hms": "ccc HH:mm:ss",
          "Ed Hms": "d ရက် E HH:mm:ss",
          "Gy Hms": "G y HH:mm:ss",
          "GyMd Hms": "G y/M/d HH:mm:ss",
          "GyMMM Hms": "G y MMM HH:mm:ss",
          "GyMMMd Hms": "G y၊ MMM d HH:mm:ss",
          "GyMMMEd Hms": "G y၊ MMM d၊ E HH:mm:ss",
          "M Hms": "L HH:mm:ss",
          "Md Hms": "d/M HH:mm:ss",
          "MEd Hms": "d/M၊ E HH:mm:ss",
          "MMM Hms": "LLL HH:mm:ss",
          "MMMd Hms": "d MMM HH:mm:ss",
          "MMMEd Hms": "MMM d၊ E HH:mm:ss",
          "MMMMd Hms": "MMMM d HH:mm:ss",
          "MMMMEd Hms": "MMMM d ရက် E HH:mm:ss",
          "y Hms": "y HH:mm:ss",
          "yM Hms": "M/y HH:mm:ss",
          "yMd Hms": "d/M/y HH:mm:ss",
          "yMEd Hms": "d/M/y၊ E HH:mm:ss",
          "yMMM Hms": "MMM y HH:mm:ss",
          "yMMMd Hms": "y၊ MMM d HH:mm:ss",
          "yMMMEd Hms": "y၊ MMM d၊ E HH:mm:ss",
          "yMMMM Hms": "y MMMM HH:mm:ss",
          "y၊ MMMM d၊ EEEE hmsv": "y၊ MMMM d၊ EEEE v a h:mm:ss",
          "y၊ MMMM d hmsv": "y၊ MMMM d v a h:mm:ss",
          "y၊ MMM d hmsv": "y၊ MMM d v a h:mm:ss",
          "d/M/yy hmsv": "d/M/yy v a h:mm:ss",
          "d hmsv": "d v a h:mm:ss",
          "E hmsv": "ccc v a h:mm:ss",
          "Ed hmsv": "d ရက် E v a h:mm:ss",
          "Gy hmsv": "G y v a h:mm:ss",
          "GyMd hmsv": "G y/M/d v a h:mm:ss",
          "GyMMM hmsv": "G y MMM v a h:mm:ss",
          "GyMMMd hmsv": "G y၊ MMM d v a h:mm:ss",
          "GyMMMEd hmsv": "G y၊ MMM d၊ E v a h:mm:ss",
          "M hmsv": "L v a h:mm:ss",
          "Md hmsv": "d/M v a h:mm:ss",
          "MEd hmsv": "d/M၊ E v a h:mm:ss",
          "MMM hmsv": "LLL v a h:mm:ss",
          "MMMd hmsv": "d MMM v a h:mm:ss",
          "MMMEd hmsv": "MMM d၊ E v a h:mm:ss",
          "MMMMd hmsv": "MMMM d v a h:mm:ss",
          "MMMMEd hmsv": "MMMM d ရက် E v a h:mm:ss",
          "y hmsv": "y v a h:mm:ss",
          "yM hmsv": "M/y v a h:mm:ss",
          "yMd hmsv": "d/M/y v a h:mm:ss",
          "yMEd hmsv": "d/M/y၊ E v a h:mm:ss",
          "yMMM hmsv": "MMM y v a h:mm:ss",
          "yMMMd hmsv": "y၊ MMM d v a h:mm:ss",
          "yMMMEd hmsv": "y၊ MMM d၊ E v a h:mm:ss",
          "yMMMM hmsv": "y MMMM v a h:mm:ss",
          "y၊ MMMM d၊ EEEE Hmsv": "y၊ MMMM d၊ EEEE v HH:mm:ss",
          "y၊ MMMM d Hmsv": "y၊ MMMM d v HH:mm:ss",
          "y၊ MMM d Hmsv": "y၊ MMM d v HH:mm:ss",
          "d/M/yy Hmsv": "d/M/yy v HH:mm:ss",
          "d Hmsv": "d v HH:mm:ss",
          "E Hmsv": "ccc v HH:mm:ss",
          "Ed Hmsv": "d ရက် E v HH:mm:ss",
          "Gy Hmsv": "G y v HH:mm:ss",
          "GyMd Hmsv": "G y/M/d v HH:mm:ss",
          "GyMMM Hmsv": "G y MMM v HH:mm:ss",
          "GyMMMd Hmsv": "G y၊ MMM d v HH:mm:ss",
          "GyMMMEd Hmsv": "G y၊ MMM d၊ E v HH:mm:ss",
          "M Hmsv": "L v HH:mm:ss",
          "Md Hmsv": "d/M v HH:mm:ss",
          "MEd Hmsv": "d/M၊ E v HH:mm:ss",
          "MMM Hmsv": "LLL v HH:mm:ss",
          "MMMd Hmsv": "d MMM v HH:mm:ss",
          "MMMEd Hmsv": "MMM d၊ E v HH:mm:ss",
          "MMMMd Hmsv": "MMMM d v HH:mm:ss",
          "MMMMEd Hmsv": "MMMM d ရက် E v HH:mm:ss",
          "y Hmsv": "y v HH:mm:ss",
          "yM Hmsv": "M/y v HH:mm:ss",
          "yMd Hmsv": "d/M/y v HH:mm:ss",
          "yMEd Hmsv": "d/M/y၊ E v HH:mm:ss",
          "yMMM Hmsv": "MMM y v HH:mm:ss",
          "yMMMd Hmsv": "y၊ MMM d v HH:mm:ss",
          "yMMMEd Hmsv": "y၊ MMM d၊ E v HH:mm:ss",
          "yMMMM Hmsv": "y MMMM v HH:mm:ss",
          "y၊ MMMM d၊ EEEE hmv": "y၊ MMMM d၊ EEEE v a h:mm",
          "y၊ MMMM d hmv": "y၊ MMMM d v a h:mm",
          "y၊ MMM d hmv": "y၊ MMM d v a h:mm",
          "d/M/yy hmv": "d/M/yy v a h:mm",
          "d hmv": "d v a h:mm",
          "E hmv": "ccc v a h:mm",
          "Ed hmv": "d ရက် E v a h:mm",
          "Gy hmv": "G y v a h:mm",
          "GyMd hmv": "G y/M/d v a h:mm",
          "GyMMM hmv": "G y MMM v a h:mm",
          "GyMMMd hmv": "G y၊ MMM d v a h:mm",
          "GyMMMEd hmv": "G y၊ MMM d၊ E v a h:mm",
          "M hmv": "L v a h:mm",
          "Md hmv": "d/M v a h:mm",
          "MEd hmv": "d/M၊ E v a h:mm",
          "MMM hmv": "LLL v a h:mm",
          "MMMd hmv": "d MMM v a h:mm",
          "MMMEd hmv": "MMM d၊ E v a h:mm",
          "MMMMd hmv": "MMMM d v a h:mm",
          "MMMMEd hmv": "MMMM d ရက် E v a h:mm",
          "y hmv": "y v a h:mm",
          "yM hmv": "M/y v a h:mm",
          "yMd hmv": "d/M/y v a h:mm",
          "yMEd hmv": "d/M/y၊ E v a h:mm",
          "yMMM hmv": "MMM y v a h:mm",
          "yMMMd hmv": "y၊ MMM d v a h:mm",
          "yMMMEd hmv": "y၊ MMM d၊ E v a h:mm",
          "yMMMM hmv": "y MMMM v a h:mm",
          "y၊ MMMM d၊ EEEE Hmv": "y၊ MMMM d၊ EEEE v HH:mm",
          "y၊ MMMM d Hmv": "y၊ MMMM d v HH:mm",
          "y၊ MMM d Hmv": "y၊ MMM d v HH:mm",
          "d/M/yy Hmv": "d/M/yy v HH:mm",
          "d Hmv": "d v HH:mm",
          "E Hmv": "ccc v HH:mm",
          "Ed Hmv": "d ရက် E v HH:mm",
          "Gy Hmv": "G y v HH:mm",
          "GyMd Hmv": "G y/M/d v HH:mm",
          "GyMMM Hmv": "G y MMM v HH:mm",
          "GyMMMd Hmv": "G y၊ MMM d v HH:mm",
          "GyMMMEd Hmv": "G y၊ MMM d၊ E v HH:mm",
          "M Hmv": "L v HH:mm",
          "Md Hmv": "d/M v HH:mm",
          "MEd Hmv": "d/M၊ E v HH:mm",
          "MMM Hmv": "LLL v HH:mm",
          "MMMd Hmv": "d MMM v HH:mm",
          "MMMEd Hmv": "MMM d၊ E v HH:mm",
          "MMMMd Hmv": "MMMM d v HH:mm",
          "MMMMEd Hmv": "MMMM d ရက် E v HH:mm",
          "y Hmv": "y v HH:mm",
          "yM Hmv": "M/y v HH:mm",
          "yMd Hmv": "d/M/y v HH:mm",
          "yMEd Hmv": "d/M/y၊ E v HH:mm",
          "yMMM Hmv": "MMM y v HH:mm",
          "yMMMd Hmv": "y၊ MMM d v HH:mm",
          "yMMMEd Hmv": "y၊ MMM d၊ E v HH:mm",
          "yMMMM Hmv": "y MMMM v HH:mm",
          "y၊ MMMM d၊ EEEE ms": "y၊ MMMM d၊ EEEE mm:ss",
          "y၊ MMMM d ms": "y၊ MMMM d mm:ss",
          "y၊ MMM d ms": "y၊ MMM d mm:ss",
          "d/M/yy ms": "d/M/yy mm:ss",
          "d ms": "d mm:ss",
          "E ms": "ccc mm:ss",
          "Ed ms": "d ရက် E mm:ss",
          "Gy ms": "G y mm:ss",
          "GyMd ms": "G y/M/d mm:ss",
          "GyMMM ms": "G y MMM mm:ss",
          "GyMMMd ms": "G y၊ MMM d mm:ss",
          "GyMMMEd ms": "G y၊ MMM d၊ E mm:ss",
          "M ms": "L mm:ss",
          "Md ms": "d/M mm:ss",
          "MEd ms": "d/M၊ E mm:ss",
          "MMM ms": "LLL mm:ss",
          "MMMd ms": "d MMM mm:ss",
          "MMMEd ms": "MMM d၊ E mm:ss",
          "MMMMd ms": "MMMM d mm:ss",
          "MMMMEd ms": "MMMM d ရက် E mm:ss",
          "y ms": "y mm:ss",
          "yM ms": "M/y mm:ss",
          "yMd ms": "d/M/y mm:ss",
          "yMEd ms": "d/M/y၊ E mm:ss",
          "yMMM ms": "MMM y mm:ss",
          "yMMMd ms": "y၊ MMM d mm:ss",
          "yMMMEd ms": "y၊ MMM d၊ E mm:ss",
          "yMMMM ms": "y MMMM mm:ss"
        }
      },
      "intervalFormats": {
        "intervalFormatFallback": "{0} – {1}",
        "Bh": {
          "B": "h B – h B",
          "h": "h – h B"
        },
        "Bhm": {
          "B": "h:mm B – h:mm B",
          "h": "h:mm – h:mm B",
          "m": "h:mm – h:mm B"
        },
        "d": {
          "d": "d – d"
        },
        "Gy": {
          "G": "G y – G y",
          "y": "G y – y"
        },
        "GyM": {
          "G": "G y/M – G y/M",
          "M": "G y/M – y/M",
          "y": "G y/M – y/M"
        },
        "GyMd": {
          "d": "G y/M/d – y/M/d",
          "G": "G y/M/d – G y/M/d",
          "M": "G y/M/d – y/M/d",
          "y": "G y/M/d – y/M/d"
        },
        "GyMEd": {
          "d": "G y/M/d၊ E – y/M/d၊ E",
          "G": "G y/M/d၊ E – G y/M/d၊ E",
          "M": "G y/M/d၊ E – y/M/d၊ E",
          "y": "G y/M/d၊ E – y/M/d၊ E"
        },
        "GyMMM": {
          "G": "G y MMM – G y MMM",
          "M": "G y MMM–MMM",
          "y": "G y MMM – y MMM"
        },
        "GyMMMd": {
          "d": "G y MMM d – d",
          "G": "G y MMM d – G y MMM d",
          "M": "G y MMM d – MMM d",
          "y": "G y MMM d – y MMM d"
        },
        "GyMMMEd": {
          "d": "G y MMM d၊ E – MMM d၊ E",
          "G": "G y MMM d၊ E – G y MMM d၊ E",
          "M": "G y MMM d၊ E – MMM d၊ E",
          "y": "G y MMM d၊ E – y MMM d၊ E"
        },
        "h": {
          "a": "a h – a h",
          "h": "a h – h"
        },
        "H": {
          "H": "HH – HH"
        },
        "hm": {
          "a": "a h:mm – a h:mm",
          "h": "a h:mm – h:mm",
          "m": "a h:mm – h:mm"
        },
        "Hm": {
          "H": "HH:mm – HH:mm",
          "m": "HH:mm – HH:mm"
        },
        "hmv": {
          "a": "v a h:mm – a h:mm",
          "h": "v a h:mm – h:mm",
          "m": "v a h:mm – h:mm"
        },
        "Hmv": {
          "H": "v HH:mm – HH:mm",
          "m": "v HH:mm – HH:mm"
        },
        "hv": {
          "a": "v a h – a h",
          "h": "v a h – h"
        },
        "Hv": {
          "H": "v HH – HH"
        },
        "M": {
          "M": "M – M"
        },
        "Md": {
          "d": "d/M – d/M",
          "M": "d/M – d/M"
        },
        "MEd": {
          "d": "d/M၊ EEEE – d/M၊ EEEE",
          "M": "d/M- EEEE – d/M- EEEE"
        },
        "MMM": {
          "M": "MMM – MMM"
        },
        "MMMd": {
          "d": "MMM d – d",
          "M": "MMM d – MMM d"
        },
        "MMMEd": {
          "d": "MMM d၊ E – MMM d၊ E",
          "M": "MMM d၊ E – MMM d၊ E"
        },
        "y": {
          "y": "y – y"
        },
        "yM": {
          "M": "M/y – M/y",
          "y": "M/y – M/y"
        },
        "yMd": {
          "d": "d/M/y – d/M/y",
          "M": "d/M/y – d/M/y",
          "y": "d/M/y – d/M/y"
        },
        "yMEd": {
          "d": "d/M/y၊ EEEE – d/M/y၊ EEEE",
          "M": "d/M/y၊ EEEE – d/M/y၊ EEEE",
          "y": "d/M/y၊ EEEE – d/M/y၊ EEEE"
        },
        "yMMM": {
          "M": "y MMM – MMM",
          "y": "y MMM – y MMM"
        },
        "yMMMd": {
          "d": "y၊ MMM d – d",
          "M": "y၊ MMM d – MMM d",
          "y": "y၊ MMM d – y၊ MMM d"
        },
        "yMMMEd": {
          "d": "y၊ MMM d၊ EEEE – MMM d၊ EEEE",
          "M": "y၊ MMM d၊ EEEE – MMM d၊ EEEE",
          "y": "y၊ MMM d၊ EEEE – y၊ MMM d၊ EEEE"
        },
        "yMMMM": {
          "M": "y MMMM – MMMM",
          "y": "y MMMM – y MMMM"
        }
      },
      "hourCycle": "",
      "nu": ["mymr"],
      "ca": ["gregory"],
      "hc": ["", "", "h23", "h12"]
    },
    "locale": "my"
  });
}